import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
//Reverting back to language controller as HTMLCsvExport components doesn't support mark-up as child of <th> 
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import { Link } from 'react-router-dom';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('ERRORS_WARNINGS_ENTRY', LOG_LEVELS.DEBUG);

class ErrorsAndWarningsEntry extends Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  onChange(event)  {
    log.debug('onChange():  ',  event);
    if (typeof this.props.onSelect === 'function') return this.props.onSelect(event.target.checked);
  }
    render() {
      log.debug('render(): ', this.props);
      if (this.props.header) {
        if (this.props.disableSelectors) {
          return (
            <tr>
              <th>{LANGUAGES_CONTROLLER.format(this.props.languages, "errorsAndWarnings_documentReference")}</th>              
              <th>{LANGUAGES_CONTROLLER.format(this.props.languages, "errorsAndWarnings_description")}</th>
            </tr>
          )
        }
        return (
          <tr>            
            <th>
              {
                this.props.formInitialising ? (<span></span>) :
                  (<span><input checked={this.props.selected} type="checkbox" onChange={this.onChange} /></span>)
              }
            </th>
            <th>{LANGUAGES_CONTROLLER.format(this.props.languages, "errorsAndWarnings_documentReference")}</th> 
            <th>{LANGUAGES_CONTROLLER.format(this.props.languages, "errorsAndWarnings_description")}</th>
          </tr>
        )
      }
      if (this.props.none) {
        if (this.props.disableSelectors) {
          return (<tr><td colSpan={4}><LanguageStringResolver string="errorsAndWarnings_noResults"/></td></tr>);
        }
        return (<tr><td colSpan={5}><LanguageStringResolver string="errorsAndWarnings_noResults"/></td></tr>);
      }
      if (this.props.disableSelectors) {
        return (
          <tr>
            <td><span>{this.props.value.invoiceNumber}</span></td>
            <td><span>{this.props.value.message}</span></td>
          </tr>
        );
      }
      
      // Put the correct link on the description, Errors get XML detail, Warnings get IFA
      let description = this.props.value.message;
      let linkedDescription, helpfultHint;
      if(this.props.value.type === 'Error') {
         linkedDescription = <Link to={'/ErrorDocumentDetail/' + this.props.value.id}>{description}</Link>
      } else {
        if(this.props.value.documentId !== 0) {
          linkedDescription = <Link to={'/TransactionSearch?exactMatch&reference=' + this.props.value.documentId + '&searchType=1'}>{description}</Link>
        } else {
          //TODO this could be improved if the API could return the error id in this case to call /ErrorDocumentDetail/$errorId
          linkedDescription = description;
          helpfultHint = <LanguageStringResolver string="errorsAndWarnings_warningAlsoError"/>;
        }
      }

      return (
        <tr>
          <td>
            {
              (this.props.formInitialising || this.props.value.id === null ) ? (<span></span>) :
                (<span><input checked={this.props.selected} type="checkbox" onChange={this.onChange}/></span>)
            }
          </td>
          <td><span>{this.props.value.invoiceNumber}</span></td>
          <td><p>{linkedDescription}</p><p><i>{helpfultHint}</i></p></td>
        </tr>
      );
    }
}


function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}

export default connect(mapStateToProps)(ErrorsAndWarningsEntry);
